import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {withRouter,Link} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../components/AppAnimate/index";
import AppCard from "../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import SubTitle from "../../components/elements/SubTitle";
import SingleCartItem from "./components/SingleCartItem";
import {currencySymbol, price} from "../../../config/values";
import Divider from "@material-ui/core/Divider/Divider";
import Button from "@material-ui/core/Button/Button";
import CheckForUserConfirmed from "../../components/elements/CheckForUserConfirmed";

class CheckoutPage extends React.Component {

    state = {
        carts:[],
        loading: true,
        SubmitLoading: false,
        total_price:null,
        total_count:null,
        total_discount:null,
    };
    classes = this.props.classes;
    componentDidMount(){
        this.loadData();
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/get_my_cart/0`, config)
                .then(response => {
                    if(!response.data.total_price) this.props.history.push('/dashboard');
                    console.log(response.data.carts)
                    this.setState({
                        carts:response.data.carts,
                        total_price:response.data.total_price,
                        total_discount:response.data.total_discount,
                        total_count:response.data.total_count,
                        loading: false
                    });
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    render(){
        let {SubmitLoading,loading,carts,total_price,total_discount,total_count} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.checkout}>
                {
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12} md={8} lg={9}>
                            <Grid container spacing={2} justify="center">
                                <Grid item xs={12}>
                                    <AppCard
                                        title={Translate.checkout}
                                        action={
                                            <BreadCrumbs singleLevel firstText={Translate.checkout}/>
                                        }>
                                        {
                                            loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2} justify="center" alignItems="center" style={{marginBottom:10}}>
                                                    <Grid item xs={12}>
                                                        {/*<CheckForUserConfirmed/>*/}
                                                        <SubTitle align="left">{Translate.productsInCart}</SubTitle>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {
                                                            !!carts.length &&
                                                                carts.map((cart,index) => (
                                                                    <SingleCartItem key={index} cart={cart}/>
                                                                ))
                                                        }
                                                    </Grid>
                                                </Grid>
                                        }
                                    </AppCard>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <Grid container spacing={2} alignItems="center" justify="center" className="sticky-grid">
                                <Grid item xs={12}>
                                    <AppCard
                                        title={Translate.bill}

                                    >
                                        {
                                            loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} className="mt-15">
                                                        <Typography
                                                            style={{color: "#737373"}}>{Translate.totalPrice} ({total_count}) <span
                                                            className="float-left">{price(total_price + total_discount) + " " + currencySymbol}</span></Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography>{Translate.totalCartPrice} <strong
                                                            className="float-left">{price(total_price) + " " + currencySymbol}</strong></Typography>
                                                    </Grid>
                                                    {
                                                        !!total_discount &&
                                                            <>
                                                                <Grid item xs={12}>
                                                                    <Divider/>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography color="secondary">{Translate.totalDiscounts} <strong
                                                                        className="float-left">{price(total_discount) + " " + currencySymbol}</strong></Typography>
                                                                </Grid>
                                                            </>
                                                    }
                                                    <Grid item xs={12}  className="mt-15">
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            styleForParent={{marginBottom:10}}
                                                            style={{width: "100%"}}
                                                            component={Link}
                                                            to='/order'
                                                            loading={SubmitLoading}
                                                        >
                                                            {Translate.resumeOrder}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                        }
                                    </AppCard>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                }
            </AppAnimate>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(CheckoutPage))));